import { render, staticRenderFns } from "./SidebarGroup.vue?vue&type=template&id=3a8a2e47"
import script from "./SidebarGroup.vue?vue&type=script&lang=js"
export * from "./SidebarGroup.vue?vue&type=script&lang=js"
import style0 from "./SidebarGroup.vue?vue&type=style&index=0&id=3a8a2e47&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports